import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function DatenschutzPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="datenschutz-page">
      <Navbar />

      <section className="pt-20 bg-[#002FA7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFD700]">Rechtliches</span>
          <h1
            className="text-4xl sm:text-5xl tracking-tighter font-black text-white mt-2"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="datenschutz-heading"
          >
            Datenschutzerklärung
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose-sm text-[#475569] leading-relaxed space-y-10">

            {/* 1. Verantwortlicher */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>1. Verantwortlicher</h2>
              <div className="space-y-1 text-sm">
                <p className="font-semibold text-[#0A0A0A]">AtoB Logistic Solutions GmbH</p>
                <p>Schneiderstr. 63</p>
                <p>40764 Langenfeld (Rheinland)</p>
                <p>Geschäftsführer: Admir Basic</p>
                <p>Telefon: +49 2122 3298877</p>
                <p>E-Mail: info@atob-logistics.de</p>
              </div>
            </div>

            {/* 2. Datenschutzbeauftragter */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>2. Datenschutzbeauftragter</h2>
              <div className="space-y-1 text-sm">
                <p className="font-semibold text-[#0A0A0A]">DSB Business Solutions GmbH</p>
                <p>Alessandro Costantino</p>
                <p>E-Mail: datenschutz@atob-logistics.de</p>
              </div>
            </div>

            {/* 3. Übersicht der Verarbeitungen */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>3. Übersicht der Verarbeitungen</h2>
              <p className="text-sm">
                Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen Personen.
              </p>
              <div className="mt-3 text-sm space-y-2">
                <p><strong className="text-[#0A0A0A]">Arten der verarbeiteten Daten:</strong></p>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Bestandsdaten (z.B. Namen, Adressen)</li>
                  <li>Kontaktdaten (z.B. E-Mail, Telefonnummern)</li>
                  <li>Inhaltsdaten (z.B. Eingaben in Formularen)</li>
                  <li>Vertragsdaten (z.B. Vertragsgegenstand, Laufzeit)</li>
                  <li>Nutzungsdaten (z.B. besuchte Webseiten, Zugriffszeiten)</li>
                  <li>Meta-/Kommunikationsdaten (z.B. Geräte-Informationen, IP-Adressen)</li>
                </ul>
              </div>
            </div>

            {/* 4. Rechtsgrundlagen */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>4. Maßgebliche Rechtsgrundlagen</h2>
              <p className="text-sm">
                Im Folgenden erhalten Sie eine Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten:
              </p>
              <ul className="list-disc pl-5 space-y-2 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO)</strong> – Die betroffene Person hat ihre Einwilligung in die Verarbeitung der sie betreffenden personenbezogenen Daten für einen spezifischen Zweck gegeben.</li>
                <li><strong className="text-[#0A0A0A]">Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</strong> – Die Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene Person ist, oder zur Durchführung vorvertraglicher Maßnahmen erforderlich.</li>
                <li><strong className="text-[#0A0A0A]">Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</strong> – Die Verarbeitung ist zur Wahrung der berechtigten Interessen des Verantwortlichen oder eines Dritten erforderlich.</li>
              </ul>
            </div>

            {/* 5. Kontaktformular */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>5. Kontaktformular</h2>
              <p className="text-sm">
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Verarbeitete Daten:</strong> Name, E-Mail-Adresse, Nachrichteninhalt</li>
                <li><strong className="text-[#0A0A0A]">Rechtsgrundlage:</strong> Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b DSGVO), berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</li>
                <li><strong className="text-[#0A0A0A]">Speicherdauer:</strong> Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind, spätestens nach 6 Monaten</li>
              </ul>
            </div>

            {/* 6. Fahrzeugbuchung */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>6. Fahrzeugbuchung und Mietverträge</h2>
              <p className="text-sm">
                Im Rahmen der Fahrzeugvermietung erheben und verarbeiten wir personenbezogene Daten, die für die Durchführung des Mietverhältnisses erforderlich sind.
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Verarbeitete Daten:</strong> Name, E-Mail-Adresse, Telefonnummer, gewünschter Mietzeitraum, Fahrzeugauswahl, Angebotspreis</li>
                <li><strong className="text-[#0A0A0A]">Zweck:</strong> Bearbeitung und Durchführung Ihrer Buchungsanfrage, Erstellung eines Mietangebots, Kommunikation bezüglich der Buchung</li>
                <li><strong className="text-[#0A0A0A]">Rechtsgrundlage:</strong> Vertragserfüllung und vorvertragliche Maßnahmen (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</li>
                <li><strong className="text-[#0A0A0A]">Speicherdauer:</strong> Die Daten werden für die Dauer des Vertragsverhältnisses gespeichert und darüber hinaus gemäß den gesetzlichen Aufbewahrungsfristen (in der Regel 6 bzw. 10 Jahre gemäß § 257 HGB und § 147 AO)</li>
              </ul>
            </div>

            {/* 7. E-Mail-Benachrichtigungen */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>7. E-Mail-Benachrichtigungen</h2>
              <p className="text-sm">
                Bei Abschluss einer Buchung senden wir Ihnen eine Buchungsbestätigung per E-Mail. Für den Versand nutzen wir den Dienst <strong className="text-[#0A0A0A]">Resend</strong> (Resend, Inc.). Dabei wird Ihre E-Mail-Adresse an Resend übermittelt.
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Verarbeitete Daten:</strong> E-Mail-Adresse, Buchungsdetails</li>
                <li><strong className="text-[#0A0A0A]">Rechtsgrundlage:</strong> Vertragserfüllung (Art. 6 Abs. 1 S. 1 lit. b DSGVO)</li>
                <li><strong className="text-[#0A0A0A]">Drittanbieter:</strong> Resend, Inc., USA – Datenübertragung in die USA auf Grundlage von Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO)</li>
              </ul>
            </div>

            {/* 8. Hosting */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>8. Hosting</h2>
              <p className="text-sm">
                Unser Hosting-Anbieter erhebt in sogenannten Logfiles folgende Daten, die Ihr Browser übermittelt: IP-Adresse, die Adresse der vorher besuchten Website (Referer Anfrage-Header), Datum und Uhrzeit der Anfrage, Zeitzonendifferenz zur Greenwich Mean Time, Inhalt der Anforderung, HTTP-Statuscode, übertragene Datenmenge, Website, von der die Anforderung kommt, und Informationen zu Browser und Betriebssystem.
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Rechtsgrundlage:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</li>
                <li><strong className="text-[#0A0A0A]">Speicherdauer:</strong> Server-Logfiles werden nach maximal 30 Tagen gelöscht</li>
              </ul>
            </div>

            {/* 9. Cookies */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>9. Cookies</h2>
              <p className="text-sm">
                Unsere Website verwendet technisch notwendige Cookies. Diese sind erforderlich, um die Grundfunktionen der Website sicherzustellen. Sie werden automatisch gesetzt und können nicht deaktiviert werden, ohne die Funktionalität der Website einzuschränken.
              </p>
              <ul className="list-disc pl-5 space-y-1 mt-3 text-sm">
                <li><strong className="text-[#0A0A0A]">Art:</strong> Technisch notwendige Cookies</li>
                <li><strong className="text-[#0A0A0A]">Rechtsgrundlage:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f DSGVO)</li>
                <li><strong className="text-[#0A0A0A]">Speicherdauer:</strong> Sitzungscookies werden nach Ende der Browsersitzung gelöscht</li>
              </ul>
            </div>

            {/* 10. Rechte der Betroffenen */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>10. Rechte der betroffenen Personen</h2>
              <p className="text-sm mb-3">
                Ihnen stehen als betroffene Person nach der DSGVO verschiedene Rechte zu, die sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:
              </p>
              <ul className="list-disc pl-5 space-y-2 text-sm">
                <li><strong className="text-[#0A0A0A]">Auskunftsrecht (Art. 15 DSGVO):</strong> Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet werden, und auf Auskunft über diese Daten sowie auf weitere Informationen und Kopie der Daten.</li>
                <li><strong className="text-[#0A0A0A]">Recht auf Berichtigung (Art. 16 DSGVO):</strong> Sie haben das Recht, die Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen.</li>
                <li><strong className="text-[#0A0A0A]">Recht auf Löschung (Art. 17 DSGVO):</strong> Sie haben das Recht zu verlangen, dass betreffende Daten unverzüglich gelöscht werden, bzw. alternativ nach Maßgabe der gesetzlichen Vorgaben eine Einschränkung der Verarbeitung der Daten zu verlangen.</li>
                <li><strong className="text-[#0A0A0A]">Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie haben das Recht zu verlangen, dass die Verarbeitung der Sie betreffenden Daten eingeschränkt wird.</li>
                <li><strong className="text-[#0A0A0A]">Recht auf Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, die Sie betreffenden Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</li>
                <li><strong className="text-[#0A0A0A]">Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden Daten Widerspruch einzulegen.</li>
                <li><strong className="text-[#0A0A0A]">Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie haben das Recht, erteilte Einwilligungen jederzeit mit Wirkung für die Zukunft zu widerrufen.</li>
                <li><strong className="text-[#0A0A0A]">Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO):</strong> Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres Firmensitzes wenden. Zuständige Aufsichtsbehörde: Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen.</li>
              </ul>
            </div>

            {/* 11. Aktualität */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-3" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>11. Aktualität und Änderung dieser Datenschutzerklärung</h2>
              <p className="text-sm">
                Diese Datenschutzerklärung ist aktuell gültig und hat den Stand April 2026. Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf dieser Website abgerufen werden.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
